import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/formulario-raas`

    return {
        datatable(queryParms) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        create(queryParms) {
            return repository.get(`${baseUrl}/create?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
    }
}